import {
  SERVICE_STATUS,
} from '@/forms/constants/services';

const uploadApiCall = async (service, payload, progressCallback) => {
  let responseFile;
  let serviceStatusCode;
  let rawResponseData;

  try {
    const rawResponse = await service(payload, progressCallback);

    responseFile = rawResponse.data['File Name'];

    // Response file can be under 'File Name' or 'file-name' property
    if (!responseFile) {
      responseFile = rawResponse.data['file-name'];
    }

    serviceStatusCode = rawResponse.status;
    rawResponseData = rawResponse.data;
  } catch (e) {
    responseFile = SERVICE_STATUS.fail;
    serviceStatusCode = e.response.status;
  }

  return {
    data: rawResponseData,
    file: responseFile,
    serviceStatusCode,
  };
};

export default uploadApiCall;
